import MapButtonGeneral from './MapButtonGeneral';

export default MapButtonGeneral;
